import React from 'react';
import PropTypes from 'prop-types';
import styles from './SplitComponent.module.css';
import '../styles/theme.css';

/*
  The same prop signature as the original (title / subtitle / par1-3 / image)
  — plus an optional `plate` React node that renders in place of the photo.
  Data.js passes a HilmaPlate per card.

  The lateral-translation scroll animation lives one level up (Home.js +
  Home.module.css), so this component renders flat and the animation is
  triggered by the parent wrapper's `.visible` class. Do not introduce any
  transform/transition here.
*/
function SplitComponent({ title, subtitle, par1, par2, par3, image, plate, capabilities }) {
  return (
    <div className={styles['split']}>
      <div className={styles['media']}>
        {plate || (image ? <img src={image} alt="" /> : null)}
      </div>

      <div className={styles['copy']}>
        {subtitle && <div className={styles['eyebrow']}>{subtitle}</div>}
        <h3 className={styles['title']}>{title}</h3>

        <div className={styles['rule']} aria-hidden="true" />

        {par1 && <p className={styles['par']}>{par1}</p>}
        {par2 && <p className={styles['par']}>{par2}</p>}
        {par3 && <p className={styles['par']}>{par3}</p>}

        {capabilities && capabilities.length > 0 && (
          <div className={styles['caps']}>
            {capabilities.map((c, i) => (
              <span
                key={c}
                className={styles['cap']}
                data-last={i === capabilities.length - 1 ? '1' : '0'}>
                {c}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

SplitComponent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  par1: PropTypes.string,
  par2: PropTypes.string,
  par3: PropTypes.string,
  image: PropTypes.string,
  plate: PropTypes.node,
  capabilities: PropTypes.arrayOf(PropTypes.string),
};

export default SplitComponent;
